"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var methods = [{
  id: 'EMAIL',
  value: 'Email'
}, {
  id: 'SMS',
  value: 'SMS'
}, {
  id: 'URL',
  value: 'URL'
}];
var currencies = [{
  id: 'RUB',
  value: 'Рубль'
}, {
  id: 'USD',
  value: 'Доллар США'
}, {
  id: 'EUR',
  value: 'Евро'
}, {
  id: 'UAH',
  value: 'Гривна'
}, {
  id: 'KZT',
  value: 'Тенге'
}, {
  id: 'CNY',
  value: 'Юань'
}, {
  id: 'VND',
  value: 'Донг'
}];

function ModifyForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      valid = _ref.valid,
      pristine = _ref.pristine;

  try {
    var shops = (0, _reactRedux.useSelector)(_functionalButton.selectShops);
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInSubmitProcess);
    return /*#__PURE__*/_react["default"].createElement("form", {
      className: _defaultModule["default"]['dialog'],
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Container, null, /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: "\u0421\u043F\u043E\u0441\u043E\u0431 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
      name: "deliveryMethod",
      simple: true,
      clearable: false,
      optionKey: "id",
      optionValue: "value",
      options: methods,
      disabled: inProcess
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      type: 'phone',
      label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      name: "phone",
      disabled: inProcess
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "Email",
      name: "email",
      disabled: inProcess
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D",
      placeholder: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043C\u0430\u0433\u0430\u0437\u0438\u043D",
      name: "shop",
      optionKey: "id",
      optionValue: "name",
      options: shops,
      disabled: inProcess,
      clearable: false,
      simple: false
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.TextareaField, {
      label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0437\u0430\u043A\u0430\u0437\u0430",
      name: "description",
      disabled: inProcess
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['amount']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['amount__value']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: 'Сумма',
      name: 'amount',
      disabled: inProcess
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['amount__currency']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: "\u0412\u0430\u043B\u044E\u0442\u0430",
      name: "currency",
      simple: true,
      clearable: false,
      optionKey: "id",
      optionValue: "value",
      options: currencies,
      disabled: inProcess
    }))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": 'submit',
      type: "submit",
      mode: "success",
      inProcess: inProcess,
      disabled: !valid || pristine
    }, "\u0412\u044B\u0441\u0442\u0430\u0432\u0438\u0442\u044C"))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

ModifyForm.defaultProps = {
  valid: false,
  pristine: true
};
var _default = ModifyForm;
exports["default"] = _default;